import {
    Header,
    UserForm,
} from '@components/export';

export const UserFormPage = (props: {
    type: string
}) => {
    return <>
        <Header/>

        <div className="page-content user-form-page">
            <div className="user-form-page-container">

                <UserForm type={props.type}/>
                <div className="company-banner"></div>
            </div>
        </div>
    </>;
};
